import React, { FC, ReactNode } from 'react';

import translate from '../../../i18n/translate';

import * as Styled from './styled';

export type Props = {
  children?: ReactNode;
  className?: HTMLButtonElement['className'];
  formId?: string;
  isDisabled?: HTMLButtonElement['disabled'];
  onClick?: () => void;
  type?: 'button' | 'submit';
};

/**
 * Button wrapper that returns reused Button with string Cancel,
 * with onClick callback
 *
 * @param props            The props passed to the component
 * @param props.children   Children to render inside the button
 * @param props.className  styled-components generated class name, needed for styling
 * @param props.formId     Whether to make the button disabled
 * @param props.isDisabled Whether to make the button disabled
 * @param props.onClick    Button click callback, can be omitted when type is submit
 * @param props.type       <button> type attribute
 * @returns                The component itself
 */
const ButtonCancel: FC<Props> = ({
  children = translate('GENERAL__CANCEL'),
  className,
  formId,
  isDisabled = false,
  onClick,
  type = 'button',
}) => {
  return (
    <Styled.ButtonCancel
      className={className}
      formId={formId}
      isDisabled={isDisabled}
      onClick={onClick}
      type={type}
    >
      {children}
    </Styled.ButtonCancel>
  );
};

export default ButtonCancel;
